import { Injectable } from '@angular/core';
import {ICreateSchedulerItemRequest, IEvent, IEventRequest, ISchedulerEvent, IUpdateSchedulerItemRequest} from "../models/scheduler";
import {BaseEditService, SchedulerModelFields} from "@progress/kendo-angular-scheduler";
import {ResourcePlanerStoreService} from "./resource-planer-store.service";
import {Observable} from "rxjs";

const fields: SchedulerModelFields = {
  id: 'TaskID',
  title: 'Title',
  description: 'Description',
  start: 'Start',
  end: 'End',
  isAllDay: 'IsAllDay',
  recurrenceRule: 'RecurrenceRule',
  recurrenceId: 'RecurrenceID',
  recurrenceExceptions: 'RecurrenceException',
};

@Injectable({
  providedIn: 'root'
})
export class ResourcePlanerEditService extends BaseEditService<ISchedulerEvent> {

  constructor(
    private resourcePlanerStore : ResourcePlanerStoreService
  ) {
    super(fields);
  }

  save(created: ISchedulerEvent[], updated: ISchedulerEvent[], deleted: ISchedulerEvent[]){

    if (created.length){
      console.log(created, "created");
      if(created[0].id){
        this.resourcePlanerStore.updateEvent(this.updateRequest(created[0]));
      } else {
        this.resourcePlanerStore.addEvent(this.createRequest(created[0]));
      }
    }

    if (deleted.length){
      this.resourcePlanerStore.deleteEvent(deleted[0].id)
    }
    this.resourcePlanerStore.listSchedulerItems();
  }

  createRequest(event : ISchedulerEvent): ICreateSchedulerItemRequest{
    const request : ICreateSchedulerItemRequest = {
      start: event.start,
      end: event.end ?? null,
      title: event.title ?? '',
      description: event.description ?? '',
      isAllDay: event.isAllDay ?? false,
      recurrenceRule : event.recurrenceRule,
      timeEntryCategoryId : event.timeEntryCategory.id,
      ressourceIds: event.ressourceIds
    }
    console.log(request, "edit service create request");
    return request;
  }

  updateRequest(event : ISchedulerEvent): IUpdateSchedulerItemRequest{
    const request : IUpdateSchedulerItemRequest = {
      start: event.start,
      end: event.end ?? null,
      title: event.title ?? '',
      description: event.description ?? '',
      isAllDay: event.isAllDay ?? false,
      id: event.id ?? null,
      recurrenceRule : event.recurrenceRule,
      timeEntryCategoryId : event.timeEntryCategory.id,
      ressourceIds: event.ressourceIds
    }
    return request;
  }
}
